import type { Router } from 'vue-router'
import { defineNuxtPlugin } from '#imports'
import analyticsService from '@services/analytics-service'

// The global navigation guard is app/middleware/navigation.global.ts.
export function installRouterHooks(router: Router) {
    // The router runs afterEach for failed navigations as well, handing the failure in
    // as the third argument. Without this test /logout, which aborts on purpose, would
    // log a page view for a page nobody sees. A guard redirect is not a failure: it
    // fires once, for the final destination.
    router.afterEach((to, from, failure) => {
        if (failure) return
        analyticsService.trackPageView()
    })
}

export default defineNuxtPlugin({
    name: 'router-hooks',
    setup(nuxtApp) {
        installRouterHooks(nuxtApp.$router as Router)
    },
})
